import React, { Component } from 'react';
import { Container, Row, Col, Tabs, Tab } from 'react-bootstrap'
import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'


class CompetResult extends Component {
    state = {
        redirect: false,
        search: '',
        key: 'maitre'
    }

    handleCHange = event => {
        const { name, value } = event.target
        this.setState({ [name]: value })
    }

    handleSubmit = event => {
        //on gere le form
        event.preventDefault()
        this.props.history.push(`/recherche/${this.state.search}`);

    }

    setRedirect = () => {
        this.setState({
          redirect: true
        })
      }

    handleSubmitFacebbok = () => {
        if (this.state.redirect) {
            window.location.href = "https://www.facebook.com/clubCAPN/";
        }
    }

    handleSelect(key) {
        if (key === "maitre")
            this.props.history.push(`/competiton/maitres-nageurs`);
        else if (key === "natation")
            this.props.history.push(`/competiton/natation`);
        else if (key === "sauvetage")
            this.props.history.push(`/competiton/sauvetage-sportif`);
        else if (key === "resultat")
            this.props.history.push(`/competiton/resultats`);
        else if (key === "synchro")
            this.props.history.push(`/competiton/nage-synchronisee`);
    }

    render() {
        return (
            <>
                <Container fluid>
                <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">

                                <Tabs
                                    id="controlled-tab"
                                    activeKey={this.state.key}
                                    onSelect={key => this.handleSelect(key)}
                                >                       <Tab eventKey="maitre" title="Maître Nageurs">
                                    </Tab>
                                    <Tab eventKey="synchro" title="Nage synchronisée">
                                    </Tab>
                                    <Tab eventKey="natation" title="Natation" >
                                    </Tab>
                                    <Tab eventKey="sauvetage" title="Sauvetage sportif">
                                    </Tab>
                                    <Tab eventKey="resultat" title="Résultats des compétitions" >
                                    </Tab>
                                </Tabs>
                            </Col>


                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                        <div className="histoire-content">
                                            <h1><span>Résultats des compétitions</span></h1>
                                            <h2>FÉLICITATIONS A TOUS LES ATHLETES RÉCIPIENDAIRES !</h2>
                                            <h3>NAGE SYNCHRONISÉE</h3>
                                             <div className="pCenter">
                                                <p className="pCenter"> Vous retrouverez les résultats des compétitions de nage synchronisée sur le site de la Fédération</p>
                                                <a className="link-history" href="https://www.synchroquebec.com/index.aspx?lang=fr">Synchro Quebec</a><br/><br/> 
                                            </div>
                                           
                                             <h3>NATATION</h3>
                                             <div className="pCenter">
                                                <p className="pCenter"> Pour consulter les résultats des compétitions, veuillez vous rendre sur le site
                                                 de la fédération de natation du Québec et veuillez sélectionner la compétition pour laquelle vous désirez avoir les résultats.</p> 
                                                 <a className="link-history" href="https://www.swimming.ca/ListeDesCompetitions.aspx?Banners=0">Liste des competitons</a><br/>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                            <div className="fixed-bottom-footer"><Footer /></div>
                            </Col>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}

export default CompetResult
